import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { duplicateService } from '@/services/duplicate';
import { useRoute } from 'vue-router';

export function useDuplicateRank() {
    const route = useRoute();

    const itemId = route.params.itemId;
    const cycleId = route.params.cycleId;

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            accountId: { type: 'number', default: null },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: duplicateService.account.getRankList,
        paramsBuilder: () => ({ ...query, duplicateItemId: itemId, duplicateCycleId: cycleId }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    return { list, total, query, fetchList };
}
